import { Trans, useTranslation } from 'react-i18next'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ps/ds/components/primitives/Select/Select'
import { Globe } from 'lucide-react'
import { CONTACT } from 'src/constants/contact'
import { NS } from 'src/constants/i18n'
import { SupportedLanguages } from 'src/types/locale'
import { getCurrentLanguage } from 'src/utils/locale/getCurrentLanguage'
import { selectLanguage } from 'src/utils/locale/selectLanguage'

const Link = (props: { target?: string; href?: string }) => (
  <a rel="noopener noreferrer" target="_blank" className="underline" {...props} />
)

export const TermsOfService = () => {
  const { t, i18n } = useTranslation(NS.TRACKING)
  const currentYear = new Date().getFullYear()

  const language = getCurrentLanguage(i18n)
  const changeLanguage = (value: SupportedLanguages) => selectLanguage(i18n, value)

  return (
    <div className="flex flex-col gap-8" data-testid="terms-of-service-section">
      <Select value={language} onValueChange={changeLanguage}>
        <SelectTrigger
          className="mx-auto w-full md:w-fit md:min-w-[172px]"
          aria-label={t('language.select.label')}>
          <span>
            <span className="flex flex-row gap-2 items-center">
              <Globe className="h-4 w-4 shrink-0 text-muted-foreground" />
              <SelectValue />
            </span>
          </span>
        </SelectTrigger>

        <SelectContent>
          <SelectGroup>
            <SelectItem value="en">{t('language.select.options.en')}</SelectItem>
            <SelectItem value="es">{t('language.select.options.es')}</SelectItem>
          </SelectGroup>
        </SelectContent>
      </Select>

      <p className="text-center text-wrap text-muted-foreground">
        <Trans
          i18nKey={`${NS.TRACKING}:terms.description`}
          values={{ contactEmail: CONTACT.SUPPORT_EMAIL }}
          components={{
            contactEmail: <Link href={`mailto:${CONTACT.SUPPORT_EMAIL}`} />,
            termsOfServiceLink: <Link href={t('terms.links.termsOfService')} />,
            requestTermsLink: <Link href={t('terms.links.requestTerms')} />,
            privacyNoticeLink: <Link href={t('terms.links.privacyNotice')} />,
            californiaPrivacyNotice: <Link href={t('terms.links.californiaPrivacyNotice')} />,
          }}
        />
      </p>

      <p className="text-center text-muted-foreground">
        {t('terms.copyright', { year: currentYear })}
      </p>
    </div>
  )
}
